/**
 * Websocket data actions
 * @namespace websocket_actions
 * @category Redux
 * @subcategory Actions
 */
// eslint-disable-next-line
const websocket_actions = {};
//used for the namespace in the documentation

/**
 * Websocket avl data action
 * @category Redux
 * @subcategory Actions
 * @memberof websocket_actions
 * @function setAVLData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setAVLData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_WEBSOCKET_AVL_DATA", payload: value });
  };
};
/**
 * Websocket hobo data action
 * @category Redux
 * @subcategory Actions
 * @memberof websocket_actions
 * @function setHoboData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setHoboData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_WEBSOCKET_HOBO_DATA", payload: value });
  };
};
/**
 * Websocket spark data action
 * @category Redux
 * @subcategory Actions
 * @memberof websocket_actions
 * @function setSparkData
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setSparkData = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_WEBSOCKET_SPARK_DATA", payload: value });
  };
};
